import { render } from "./AttributionReport.vue?vue&type=template&id=5319bd67"
import script from "./AttributionReport.vue?vue&type=script&lang=js"
export * from "./AttributionReport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__